import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderTitleStyleContainer } from "./style";
import CompanyLogo from "../company-logo";
import { useApplicationContext } from "../../context/application-context";
const HeaderTitle = ({ title, isBackTrue = true, logo: any }) => {
    const { tenantSettings } = useApplicationContext();
    return (_jsxs(HeaderTitleStyleContainer, { children: [_jsx("div", Object.assign({ className: "arrow-back-title-wrapper" }, { children: _jsx("div", Object.assign({ className: "title-container" }, { children: title })) })), _jsx("div", Object.assign({ className: "logo-wrapper" }, { children: tenantSettings.tenantConfig.brandLogo && (_jsx(CompanyLogo, { brandLogo: tenantSettings.tenantConfig.brandLogo.whiteBgLogo })) }))] }));
};
export default HeaderTitle;
